module.exports = __webpack_public_path__ + "img/tutorial-1.76630edd.png";